module.exports = __webpack_public_path__ + "fonts/NespressoLucas-BoldItalic.svg?v=646bf8fc274e36e9f731cc1c64c45617";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-BoldItalic.svg
// module id = 629
// module chunks = 0